import { request } from "@/interface/helper";

const str = "missionManage";

export const missionManage = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/mission/manage/list" }),
    add: (data) => request({ data, method: "post", url: "/mission/manage/add" }),
    detail: (data) => request({ data, method: "post", url: "/mission/manage/detail" }),
    edit: (data) => request({ data, method: "post", url: "/mission/manage/modify" }),
  },
};
